var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settlement-consignee-node"},[_c('button',{staticClass:"settlement-button",class:{'active':_vm.active},on:{"click":_vm.handleClick}},[_c('span',[_vm._v("李先生 山东")])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settlement-address"},[_c('span',[_vm._v("李先生 山东 历城 致远街道 中山东路中联花园B区 178****0921")])])
}]

export { render, staticRenderFns }